/* Sunnah PDP — behaviour. No jQuery: the layout loads none of the theme's vendor bundles.
   Add-to-cart is a plain POST to /cart/add.js, then the UpCart drawer is opened (window.upcartOpenCart —
   the same call LP2 uses), falling back to the section's "After add, go to" URL, then /cart.
   R33 (24-Sep-2026): previously redirected straight to /checkout, which skipped the drawer, the rewards
   bar and the wallet buttons. Gifts are no longer added here; UpCart's reward tiers add them, as on LP2.
   Four tiers (3-bottle one-time / 3-month sub / 1-month sub / one bottle) live as .sp-plan cards; the chosen
   card's data-variant / data-plan / data-gifts drive the add. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- buy box: tier cards ---------- */
  var buy = $('[data-sp-buy]');
  var btn = buy && $('[data-sp-add]', buy);
  function current() { return buy && $('.sp-plan.is-on', buy); }
  function sync() {
    var card = current();
    if (!card || !btn) return;
    btn.textContent = card.getAttribute('data-label') || btn.getAttribute('data-label-default') || btn.textContent;
    var sub = $('[data-sp-cta-sub]', buy);
    if (sub) sub.textContent = card.getAttribute('data-sub') || '';
  }
  if (buy) {
    $$('.sp-plan', buy).forEach(function (card) {
      var input = $('input', card);
      function select() {
        $$('.sp-plan', buy).forEach(function (c) { c.classList.remove('is-on'); });
        card.classList.add('is-on');
        if (input) input.checked = true;
        sync();
      }
      card.addEventListener('click', select);
      if (input) input.addEventListener('change', select);
    });
    sync();
  }

  /* ---------- add to cart → open the cart drawer ---------- */
  /* data-gifts is still honoured if a tier sets gift variant ids in the theme editor (explicit $0 line items),
     but the live template leaves it empty so UpCart's reward tiers add the gifts — identical to LP2.
     If a gift can't be added (sold out), the gummies are added on their own. */
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    });
  }
  function reset() {
    btn.classList.remove('is-busy');
    btn.removeAttribute('disabled');
  }
  function openCart() {
    if (window.upcartRefreshCart) { try { window.upcartRefreshCart(); } catch (e) {} }
    if (window.upcartOpenCart) {
      try { window.upcartOpenCart(); reset(); return; } catch (e) {}
    }
    window.location.href = btn.getAttribute('data-after') || '/cart';
  }
  function addAndOpen() {
    var card = current();
    if (!card) return;
    var variant = parseInt(card.getAttribute('data-variant'), 10);
    if (!variant) return;
    var plan = parseInt(card.getAttribute('data-plan') || '0', 10);
    var item = { id: variant, quantity: 1 };
    if (plan) item.selling_plan = plan;
    var items = [item];
    (card.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
      var id = parseInt(g.trim(), 10);
      if (id) items.push({ id: id, quantity: 1 });
    });
    var err = $('.sp-cta__err', buy);
    if (err) err.classList.remove('is-on');
    btn.classList.add('is-busy');
    btn.setAttribute('disabled', 'disabled');
    postAdd(items).catch(function (e) {
      if (items.length < 2) throw e;
      return postAdd([item]);
    }).then(function () {
      openCart();
    }).catch(function (e) {
      reset();
      if (err) { err.textContent = e.message || 'Something went wrong — please try again.'; err.classList.add('is-on'); }
    });
  }
  if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); addAndOpen(); });

  /* ---------- sticky bar: after the hero CTA scrolls out, hidden while the buy box is on screen ---------- */
  var sticky = $('[data-sp-sticky]');
  var heroCta = $('[data-sp-hero-cta]');
  if (sticky) {
    var showAfter = heroCta || $('.sp-hero');
    var pastHero = false, onBuy = false;
    function paint() { sticky.classList.toggle('is-on', pastHero && !onBuy); }
    if ('IntersectionObserver' in window) {
      if (showAfter) new IntersectionObserver(function (es) {
        es.forEach(function (en) { pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; paint(); });
      }, { threshold: 0 }).observe(showAfter);
      if (buy) new IntersectionObserver(function (es) {
        es.forEach(function (en) { onBuy = en.isIntersecting; paint(); });
      }, { threshold: 0.15 }).observe(buy);
    } else {
      sticky.classList.add('is-on');
    }
  }

  /* ---------- lightbox: label zoom + customer videos ---------- */
  var lb = $('[data-sp-lightbox]');
  if (lb) {
    var lbImg = $('img', lb);
    var lbVideo = null;
    function clearVideo() { if (lbVideo) { lbVideo.innerHTML = ''; lbVideo.hidden = true; } lb.classList.remove('sp-lightbox--video'); }
    function close() { lb.classList.remove('is-on'); lbImg.removeAttribute('src'); lbImg.hidden = false; clearVideo(); }
    $$('[data-sp-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearVideo(); lbImg.hidden = false;
        lbImg.src = b.getAttribute('data-sp-zoom');
        lbImg.alt = b.getAttribute('data-sp-zoom-alt') || '';
        lb.classList.add('is-on');
      });
    });
    $$('[data-sp-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-sp-video');
        if (!src) return;
        if (!lbVideo) { lbVideo = document.createElement('div'); lbVideo.className = 'sp-lightbox__video'; lb.appendChild(lbVideo); }
        lbVideo.innerHTML = ''; lbImg.removeAttribute('src'); lbImg.hidden = true;
        var el;
        if (/\.mp4(\?|$)/i.test(src)) {
          el = document.createElement('video'); el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true; el.setAttribute('playsinline', '');
        } else {
          el = document.createElement('iframe'); el.src = src; el.allow = 'autoplay; fullscreen; picture-in-picture'; el.allowFullscreen = true; el.title = b.getAttribute('aria-label') || 'Customer video';
        }
        lbVideo.appendChild(el); lbVideo.hidden = false; lb.classList.add('is-on', 'sp-lightbox--video');
      });
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-sp-close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- smooth anchors (older Safari) ---------- */
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      var t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
